import { Check, X } from "lucide-react";
import { useTranslation } from "../../context/TranslationContext";

interface PasswordMatchIndicatorProps {
  password: string;
  confirmPassword: string;
  showIndicator: boolean;
  className?: string;
}

export function PasswordMatchIndicator({ 
  password, 
  confirmPassword, 
  showIndicator,
  className = "" 
}: PasswordMatchIndicatorProps) {
  const { t } = useTranslation();
  
  if (!showIndicator) {
    return null;
  }

  const passwordsMatch = password === confirmPassword && password.length > 0 && confirmPassword.length > 0;

  return (
    <div data-tsx-id="password-match-indicator" className={`flex items-center gap-1 mt-2 ${className}`}>
      {passwordsMatch ? (
        <>
          <Check className="w-3.5 h-3.5 text-green-600" />
          <span className="text-xs text-green-600">
            {t('auth.passwordMatch')}
          </span>
        </>
      ) : (
        <>
          <X className="w-3.5 h-3.5 text-zinc-300" />
          <span className="text-xs text-zinc-500">
            {t('auth.passwordsDontMatch')}
          </span>
        </>
      )}
    </div>
  );
}
